const FILTER_SLUG = '/filter';
export function getPropertyFromLink(property, link) {
    var _a;
    if (!link) {
        return '';
    }
    return (_a = getProperty(property, link)) !== null && _a !== void 0 ? _a : '';
}
function getProperty(property, link) {
    var _a, _b, _c;
    if ('absoluteUrls' in link) {
        return link.absoluteUrls[property];
    }
    else {
        if (property === 'metaDescription' && 'sitemapNode' in link) {
            return link.sitemapNode.metaDescription;
        }
        if (property === 'title') {
            if (!link.title && 'sitemapNode' in link) {
                return link.sitemapNode.title;
            }
            return link.title;
        }
        else {
            if ('product' in link) {
                return (_c = (_b = (_a = link.product) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.product) !== null && _c !== void 0 ? _c : undefined;
            }
            if ('sitemapNode' in link) {
                return link.isFilterPage
                    ? link.sitemapNode.absoluteUrl + FILTER_SLUG
                    : link.sitemapNode.absoluteUrl;
            }
            return link.absoluteUrl;
        }
    }
}
//# sourceMappingURL=getPropertyFromLink.js.map